import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { ProfilePicImage } from "../global"
import LanguageSetter from "../LanguageSetter"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTelegram, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faAt, faGlobe } from "@fortawesome/free-solid-svg-icons"



const FixedWrapper = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 2rem;
    @media (max-width: 800px) {
        position: relative;
    }

`
const LeftMenuAside = styled.aside`
    width: 601px;
    padding: 20px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #F6E7C1;

    @media (max-width: 800px) {
        width: 100%;
        height: auto;
        padding: 40px 0px;
    }
`
const MenuList = styled.ul<{ itemSize: number }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    list-style: none;
    a {
        font-size: ${props => props.itemSize}rem;
        font-family: monospace;
    }
`

const LanguagePicker = styled.div`
    font-size: x-small;
`

export default function LeftMenu() {
    useTranslation();

    return (
        <LeftMenuAside>
            <FixedWrapper>

                <Link to="/"><ProfilePicImage src="https://i.imgur.com/oa8fgaa.png" size={10} /></Link>


                <div>
                    <p><Trans i18nKey="side.im">I'm KiraaCorsac, also known as Filip Opálený.</Trans></p>
                    <p><Trans i18nKey="side.looking">Are you looking for one of the following?</Trans></p>
                </div>

                <MenuList itemSize={1.5}>
                    <li><Link to="/digital-3d-artist"><Trans i18nKey="side.threed">🦊 CGI and 3D Artist</Trans></Link></li>
                    <li><Link to="/programming-tutor"><Trans i18nKey="side.programming">💻 Programming Tutor</Trans></Link></li>
                    <li><Link to="/bioviz-researcher"><Trans i18nKey="side.bioviz">🧬 Bioviz Researcher</Trans></Link></li>
                </MenuList>

                <div>
                    <MenuList itemSize={1.2}>
                        <li><a href="mailto:filipkiraaopaleny@gmail.com">filipkiraaopaleny@gmail.com</a></li>
                    </MenuList>
                </div>

                <LanguagePicker>
                    <Trans i18nKey="side.language">Language</Trans>: <LanguageSetter name="en" label="English" /> | <LanguageSetter name="sk" label="Slovensky" /> | <LanguageSetter name="cz" label="Česky" />
                </LanguagePicker>
            </FixedWrapper>

        </LeftMenuAside>
    )
}